/**
 * @generated SignedSource<<807c6e8dd961dae500f9ddaee8d316b9>>
 * @relayHash cf3a11251bae2782447696e602cbd833
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c8c8215334c6aaae5ba752034e6f1f94c2510353995460bd924dc0af55a18cb5

import type { ConcreteRequest } from 'relay-runtime';
export type ChangeHubPublishStateWriteQuery$variables = Record<PropertyKey, never>;
export type ChangeHubPublishStateWriteQuery$data = {
  readonly siteSettings: {
    readonly frontCover: {
      readonly frontCoverState: string | null;
    } | null;
  } | null;
};
export type ChangeHubPublishStateWriteQuery = {
  response: ChangeHubPublishStateWriteQuery$data;
  variables: ChangeHubPublishStateWriteQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "concreteType": "SiteSettings",
    "kind": "LinkedField",
    "name": "siteSettings",
    "plural": false,
    "selections": [
      {
        "concreteType": "FrontCover",
        "kind": "LinkedField",
        "name": "frontCover",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "frontCoverState"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ChangeHubPublishStateWriteQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ChangeHubPublishStateWriteQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "cf3a11251bae2782447696e602cbd833",
    "id": "c8c8215334c6aaae5ba752034e6f1f94c2510353995460bd924dc0af55a18cb5",
    "metadata": {},
    "name": "ChangeHubPublishStateWriteQuery",
    "operationKind": "query",
    "text": "query ChangeHubPublishStateWriteQuery{siteSettings{frontCover{frontCoverState}}}"
  }
};
})();

(node as any).hash = "c5edd80e44855ef2031199e9bcac6386";

export default node;
